import { Navigate, useLocation, useParams } from 'react-router-dom'
import { dashboardSettingsPath } from '@/features/dashboards/dashboardSettingsLink'

/**
 * The old standalone dashboard edit page (`/dashboards/:dashboardId/edit`)
 * repeated Dashboard settings in a narrow column. Editing is now one place:
 * the dashboard in edit mode, with settings in its dialog - so old links and
 * bookmarks land there, settings open.
 */
export default function DashboardEditRedirect() {
  const { dashboardId } = useParams()
  const { search } = useLocation()
  return <Navigate to={dashboardSettingsPath(dashboardId, search)} replace />
}
